import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminLogin, adminMe, adminLogout, getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=anon, obj=admin
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setAdmin(false);
      setReady(true);
      return;
    }
    try {
      const me = await adminMe();
      setAdmin(me);
    } catch {
      clearToken();
      setAdmin(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const res = await adminLogin(email, password);
    setToken(res.access_token);
    setAdmin({ email: res.email, role: res.role || "admin" });
    return res;
  };

  const logout = async () => {
    try {
      await adminLogout();
    } catch (err) {
      console.warn("[AuthContext] Server logout failed — clearing local session anyway", err);
    }
    clearToken();
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, ready, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
